// extracted by mini-css-extract-plugin
export default {"messageBox":"PostCommentFormClosed-messageBox-5fe061fc56d1126b417cc4d3ebdf2714","icon":"PostCommentFormClosed-icon-812c1a214bc3b5c29ec7fd60d3b5dc7a"};